import './Icon.css';
export var container = '_18riimf0-3-8-0';